import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate } from "react-router-dom";

export default function CreateRolePage() {
    const navigate = useNavigate();
    const { backEnd_request, UserTypes } = BackMethods(); // 🟢 استدعاء UserTypes من BackMethods

    const [role, setRole] = useState({
        name: "",
        displayName: "",
        description: "",
        userType: 0,
        permissionIds: [],
    });

    const [permissions, setPermissions] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formError, setFormError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    // 🟢 جلب الصلاحيات من السيرفر
    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const res = await backEnd_request.get("/admin/Permissions");
                setPermissions(res.data || []);
            } catch (error) {
                console.error("فشل في جلب الصلاحيات:", error);
            }
        };
        fetchPermissions();
    }, []);

    // 🔁 تحديث بيانات الدور
    const handleChange = (field, value) => {
        setRole((prev) => ({
            ...prev,
            [field]:
                field === "userType" ? Number(value) || 0 : value,
        }));
    };

    // ✅ تبديل حالة الصلاحية
    const togglePermission = (id) => {
        setRole((prev) => {
            const exists = prev.permissionIds.includes(id);
            return {
                ...prev,
                permissionIds: exists
                    ? prev.permissionIds.filter((pid) => pid !== id)
                    : [...prev.permissionIds, id],
            };
        });
    };

    // 🔎 تحقق من المدخلات
    const validate = () => {
        if (!role.name.trim()) return "الرجاء إدخال الاسم";
        if (!role.displayName.trim()) return "الرجاء إدخال الاسم الظاهر";
        if (role.userType === 0) return "الرجاء اختيار نوع المستخدم";
        if (role.permissionIds.length === 0) return "الرجاء اختيار صلاحية واحدة على الأقل";
        return "";
    };

    // 🚀 إرسال الطلب إلى السيرفر
    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError("");
        setSuccessMessage("");

        const error = validate();
        if (error) {
            setFormError(error);
            return;
        }

        setIsSubmitting(true);
        try {
            const res = await backEnd_request.post("/admin/Roles", role);
            console.log("✅ تم إنشاء الدور:", res.data);
            navigate("/admin/roles-management", {
                state: { successMessage: "تمت إضافة الدور بنجاح!" },
            });
        } catch (err) {
            console.error(err.response?.data?.message || err);
            setFormError(err.response?.data?.message || "حدث خطأ أثناء الإرسال");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="bg-dark min-vh-100 d-flex align-items-center py-5">
            <div className="container">
                <div className="text-center mb-5">
                    <h1
                        className="text-light fw-bold"
                        style={{ fontSize: "2.3rem", letterSpacing: "1px" }}
                    >
                        إضافة دور جديد
                    </h1>
                    <p className="text-light" style={{ fontSize: "1.1rem" }}>
                        يرجى إدخال جميع المعلومات المطلوبة لإضافة دور جديد
                    </p>
                </div>

                <div className="d-flex justify-content-center">
                    <div
                        className="card border-0 shadow-lg"
                        style={{
                            width: "100%",
                            maxWidth: "750px",
                            borderRadius: "20px",
                        }}
                    >
                        <div
                            className="card-header text-center py-4"
                            style={{
                                backgroundColor: "#f8f9fa",
                                borderTopLeftRadius: "20px",
                                borderTopRightRadius: "20px",
                            }}
                        >
                            <h3 className="text-dark m-0 fw-bold">معلومات الدور</h3>
                        </div>

                        <div className="card-body bg-white p-5 rounded-bottom">
                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="الاسم (Name)"
                                            value={role.name}
                                            onChange={(e) => handleChange("name", e.target.value)}
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            className="form-control p-3"
                                            placeholder="الاسم الظاهر (Display Name)"
                                            value={role.displayName}
                                            onChange={(e) =>
                                                handleChange("displayName", e.target.value)
                                            }
                                            style={{ borderRadius: "12px" }}
                                        />
                                    </div>

                                    <div className="col-12">
                                        <textarea
                                            className="form-control p-3"
                                            placeholder="الوصف (اختياري)"
                                            rows="3"
                                            value={role.description}
                                            onChange={(e) =>
                                                handleChange("description", e.target.value)
                                            }
                                            style={{ borderRadius: "12px" }}
                                        ></textarea>
                                    </div>

                                    {/* 🟢 نوع المستخدم من BackMethods */}
                                    <div className="col-md-6">
                                        <select
                                            className="form-select p-3"
                                            value={role.userType || ""}
                                            onChange={(e) =>
                                                handleChange("userType", parseInt(e.target.value))
                                            }
                                            style={{ borderRadius: "12px" }}
                                        >
                                            <option value="">نوع المستخدم</option>
                                            {UserTypes.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* ✅ الصلاحيات */}
                                <div className="mt-4">
                                    <h5 className="fw-bold mb-3">اختر الصلاحيات:</h5>
                                    <div
                                        className="border rounded p-3"
                                        style={{
                                            maxHeight: "250px",
                                            overflowY: "auto",
                                            backgroundColor: "#f8f9fa",
                                        }}
                                    >
                                        {permissions.length === 0 ? (
                                            <p className="text-muted text-center">
                                                جارٍ تحميل الصلاحيات...
                                            </p>
                                        ) : (
                                            permissions.map((perm) => (
                                                <div
                                                    key={perm.permissionId}
                                                    className="form-check mb-2"
                                                >
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`perm-${perm.permissionId}`}
                                                        checked={role.permissionIds.includes(
                                                            perm.permissionId
                                                        )}
                                                        onChange={() =>
                                                            togglePermission(perm.permissionId)
                                                        }
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor={`perm-${perm.permissionId}`}
                                                    >
                                                        {perm.displayName}
                                                    </label>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>

                                {/* زر الإرسال */}
                                <div className="mt-4">
                                    <button
                                        type="submit"
                                        className={`btn w-100 py-3 fw-bold ${isSubmitting
                                                ? "btn-secondary"
                                                : "btn-dark text-light"
                                            }`}
                                        style={{
                                            borderRadius: "12px",
                                            fontSize: "1.1rem",
                                        }}
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? "جارٍ الإرسال..." : "إضافة الدور"}
                                    </button>
                                </div>

                                {formError && (
                                    <div className="text-danger text-center mt-3 fw-bold">
                                        {formError}
                                    </div>
                                )}
                                {successMessage && (
                                    <div className="text-success text-center mt-3 fw-bold">
                                        {successMessage}
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
